import React, {useMemo} from 'react';
import PropTypes from 'prop-types';
import PeacockDataTable from '@/components/organisms/PeacockDataTable';
import {useSimpleDataTable} from '@/hooks/useSimpleDataTable';

const WOF_QUESTIONS_PAGE_SIZE = 10;

const stringSortComparator = (data, sortConfig) => {
  return [...data].sort((a, b) => {
    const aVal = String(a[sortConfig.column] || '').toLowerCase();
    const bVal = String(b[sortConfig.column] || '').toLowerCase();
    if (aVal < bVal) return sortConfig.direction === 'desc' ? 1 : -1;
    if (aVal > bVal) return sortConfig.direction === 'desc' ? -1 : 1;
    return 0;
  });
};

const WofQuestionsTable = ({data, wrapperClassName = ''}) => {
  const {
    paginatedData,
    paginationConfig,
    selectionConfig,
    sortingConfig,
    filterConfig,
    toolbarConfig,
    displayConfig,
    pageSize
  } = useSimpleDataTable({
    data,
    pageSize: WOF_QUESTIONS_PAGE_SIZE,
    sortComparator: stringSortComparator,
    noDataTitle: 'No questions available',
    noDataDescription: 'No questions available. Please upload a template.',
    wrapperClassName
  });

  const columns = useMemo(
    () => [
      {columnKey: 'question', header: 'QUESTION', enableSorting: true},
      {columnKey: 'rightAnswer', header: 'RIGHT ANSWER', enableSorting: true},
      {
        columnKey: 'wrongAnswer1',
        header: 'WRONG ANSWER 1',
        enableSorting: true
      },
      {
        columnKey: 'wrongAnswer2',
        header: 'WRONG ANSWER 2',
        enableSorting: true
      },
      {columnKey: 'wrongAnswer3', header: 'WRONG ANSWER 3', enableSorting: true}
    ],
    []
  );

  return (
    <PeacockDataTable
      columns={columns}
      records={paginatedData}
      pageSize={pageSize}
      totalRecords={data.length}
      paginationConfig={paginationConfig}
      selectionConfig={selectionConfig}
      sortingConfig={sortingConfig}
      filterConfig={filterConfig}
      toolbarConfig={toolbarConfig}
      displayConfig={displayConfig}
    />
  );
};

WofQuestionsTable.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      question: PropTypes.string,
      rightAnswer: PropTypes.string,
      wrongAnswer1: PropTypes.string,
      wrongAnswer2: PropTypes.string,
      wrongAnswer3: PropTypes.string
    })
  ).isRequired,
  wrapperClassName: PropTypes.string
};

export default React.memo(WofQuestionsTable);
